module.exports = __webpack_public_path__ + "img/9.40e49dff.jpg";